// extracted by mini-css-extract-plugin
module.exports = {"reader":"JSONReader_reader_2ngcY"};